import { v2Api } from './v2Client';

const post = (url, body) => v2Api.post(url, body ?? {}).then((r) => r.data);

/**
 * Équipes persistantes (API `Team/*`, docs/MULTISPORT.md « Équipes et entrants »). En ERP (staff), la création prend
 * les membres (`member_player_ids`, dans l'ordre des positions) et le capitaine. Refus : `{ error, message }`.
 */
export const teamService = {
  list: (params = {}) => post('/Team/list', params),
  get: (teamId) => post('/Team/get', { team_id: teamId }),
  create: ({ sport_id, name, team_size, member_player_ids, captain_player_id }) =>
    post('/Team/create', { sport_id, name: name || '', team_size: team_size ?? null, member_player_ids, captain_player_id }),
  update: ({ team_id, name, is_active }) => post('/Team/update', { team_id, name, is_active }),
  addMember: (teamId, playerId) => post('/Team/add_member', { team_id: teamId, player_id: playerId }),
  removeMember: (teamId, playerId) => post('/Team/remove_member', { team_id: teamId, player_id: playerId }),
  setCaptain: (teamId, playerId) => post('/Team/set_captain', { team_id: teamId, player_id: playerId }),
  invites: (teamId) => post('/Team/invite/list', { team_id: teamId }),
  joinRequests: (teamId) => post('/Team/join_request/list', { team_id: teamId }),
  acceptJoinRequest: (id) => post('/Team/join_request/accept', { id }),
  declineJoinRequest: (id) => post('/Team/join_request/decline', { id }),
};